import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STRIPS = [
  {
    league: "NFL",
    cat: "nfl",
    tag: "30 Teams · Original Fan Designs",
    img: "/api/static-media/teams/nfl-dallas-hoodie.jpg",
    accent: "from-red-600/30",
  },
  {
    league: "NBA",
    cat: "nba",
    tag: "29 Teams · Original Fan Designs",
    img: "/api/static-media/teams/nba-losangeles-hoodie.jpg",
    accent: "from-purple-600/30",
  },
];

export default function LeagueStrips() {
  return (
    <section data-testid="league-strips" className="px-5 sm:px-6 md:px-12 lg:px-16 py-12 md:py-20 bg-background">
      <p className="text-xs uppercase tracking-[0.35em] font-bold text-primary mb-8">New Drops</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
        {STRIPS.map((s) => (
          <Link
            key={s.cat}
            to={`/collections/${s.cat}`}
            data-testid={`league-strip-${s.cat}`}
            className="group relative overflow-hidden border border-white/10 bg-card min-h-[240px] md:min-h-[300px] flex items-end"
          >
            <img
              src={s.img}
              alt={`Shop ${s.league}`}
              className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-500"
            />
            <div className={`absolute inset-0 bg-gradient-to-r ${s.accent} via-black/40 to-black/80`} />
            <div className="relative z-10 p-6 md:p-8">
              <h3 className="font-anton text-5xl md:text-7xl uppercase tracking-tight text-white leading-none">
                Shop <span className="text-primary">{s.league}</span>
              </h3>
              <p className="text-xs md:text-sm text-white/60 mt-2 uppercase tracking-[0.15em]">{s.tag}</p>
              <span className="inline-flex items-center gap-2 mt-5 text-sm font-bold uppercase tracking-[0.2em] text-white border-b-2 border-primary pb-1 group-hover:gap-3 transition-all">
                Explore the collection <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
